// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"136":"events","681":"users","713":"risk-level","966":"dashboard","986":"regions"}[chunkId] || chunkId) + "." + {"118":"9343895e","136":"2159b7f8","518":"cecfec54","596":"93739575","681":"f14d2894","713":"69ee281a","966":"8d38d309","986":"db9082dc"}[chunkId] + ".js";
};